// Shared between the staff announcement page and the student dashboard tab.

export const formatAnnouncementDate = (value) => {
  if (!value) return '';
  return new Date(value).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

export const audienceLabel = (announcement) => {
  if (announcement.audience === 'branch') {
    return announcement.branch?.name
      ? `Branch: ${announcement.branch.name}`
      : 'Branch';
  }
  if (announcement.audience === 'batch') {
    return announcement.batch?.batchNumber
      ? `Batch #${announcement.batch.batchNumber}`
      : 'Batch';
  }
  return 'All branches';
};

// Where a role's Announcements page lives, or null when it has none (students,
// accountants). headhr and jrhr both run inside the /headhr layout.
export const announcementsPathFor = (user) => {
  const role = user?.role;
  if (role === 'placement') {
    return ['headhr', 'jrhr'].includes(user?.hrRole)
      ? '/headhr/announcements'
      : '/placement/announcements';
  }
  if (['admin', 'superadmin', 'teacher', 'headhr'].includes(role)) {
    return `/${role === 'headhr' ? 'headhr' : role}/announcements`;
  }
  return null;
};

const ROLE_LABELS = {
  superadmin: 'Super Admin',
  admin: 'Admin',
  teacher: 'Teacher',
  placement: 'HR',
};

/**
 * Admin and superadmin are signed with the name alone; everyone else also carries
 * the role, so students know who to follow up with: "Rahul S. (Teacher)".
 */
export const postedByLabel = (announcement) => {
  const role = announcement.postedBy?.role;
  const name = announcement.postedBy?.name;
  if (role === 'admin' || role === 'superadmin') return name;
  return `${name} (${ROLE_LABELS[role] || role})`;
};

export const AudienceChip = ({ announcement }) => {
  const colors = {
    all: 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-200',
    branch: 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-200',
    batch:
      'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-200',
  };
  return (
    <span
      className={`rounded-full px-3 py-1 text-xs font-medium ${
        colors[announcement.audience] || colors.all
      }`}
    >
      {audienceLabel(announcement)}
    </span>
  );
};
